"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderArchiveMenuItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_intl_1 = require("react-intl");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const OrderArchiveMenuItem = props => {
    const { order } = props;
    const handleClick = () => {
        void order;
        alert("Not implemented!");
    };
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.Menu.Item, { onClick: handleClick, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Menu.ItemIcon, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Archive, { fontSize: "small" }) }), (0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { variant: "inherit", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.archive" }) })] }));
};
exports.OrderArchiveMenuItem = OrderArchiveMenuItem;
//# sourceMappingURL=index.js.map